import { Link } from "react-router-dom";
import { CATEGORIES } from "../../data/courses";
import styles from "./Footer.module.css";

const SOCIALS = [
  { label: "X (Twitter)", icon: "\ud835\udd4f", href: "https://x.com/ShortlyLife" },
  { label: "Instagram", icon: "\ud83d\udcf7", href: "https://instagram.com/shortly.life_official" },
];

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.glow} />
      <div className={styles.inner}>
        <div className={styles.top}>
          {/* Brand */}
          <div className={styles.brand}>
          <Link to="/" className={styles.logo}>
            <img src="/logo.svg" alt="Shortly Life" className={styles.logoImg} />
            <span className={styles.logoText}>Shortly Life</span>
          </Link>
            <p className={styles.tagline}>
              The shortcut to knowing. Bite-sized PDF courses for a fast-moving
              world — no fluff, no subscriptions. Pay once, learn forever.
            </p>
            <p className={styles.email}>
              <a href="mailto:support@shortly.life" className={styles.emailLink}>
                support@shortly.life
              </a>
            </p>
            <div className={styles.socials}>
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  className={styles.social}
                  aria-label={s.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Categories */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Categories</h4>
            {CATEGORIES.map((c) => (
              <Link key={c.id} to={"/category/" + c.id} className={styles.colLink}>
                {c.icon} {c.label}
              </Link>
            ))}
          </div>

          {/* Company */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Company</h4>
            <Link to="/about" className={styles.colLink}>About Us</Link>
            <Link to="/contact" className={styles.colLink}>Contact Us</Link>
          </div>

          {/* Legal */}
          <div className={styles.col}>
            <h4 className={styles.colTitle}>Legal</h4>
            <Link to="/refund-policy" className={styles.colLink}>Refund Policy</Link>
            <Link to="/privacy-policy" className={styles.colLink}>Privacy Policy</Link>
            <Link to="/terms" className={styles.colLink}>Terms of Service</Link>
          </div>
        </div>

        <div className={styles.bottom}>
          <p className={styles.copy}>
            &copy; {new Date().getFullYear()} Shortly Life. All rights reserved.
          </p>
          <p className={styles.copy} style={{ color: "var(--text3)" }}>
            Made with ❤️ in India · Instant PDF delivery · 100% secure payments
          </p>
        </div>
      </div>
    </footer>
  );
}